import React from "react";
import data from "../../../Data/Data";
import Btn from "../../../ReUseAbleComp/Button.jsx";
import Header from "../../../ReUseAbleComp/Header.jsx";
import Search from "../../../ReUseAbleComp/SearchInput.jsx";
import { BsArrowRight, BsArrowLeft } from "react-icons/bs";

function LGEnglish({
  searchTagUrdu,
  CovidsearchTerm,
  CovidUrduSearch,
  handleCovidChange,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <br />
      <br />
      <br />
      <br />
      <center>
        <h1>کورونا وائرس</h1>
        <Search
          handleChange={handleCovidChange}
          searchTerm={CovidsearchTerm}
          searchTagUrdu={searchTagUrdu}
          dir="rtl"
        />

        {CovidUrduSearch.map((item) => (
          <Btn
            key={item.id}
            bool={true}
            title={item.Utitle}
            id={item.RID}
            path={`/CovidUrduDetails/${item.id}`}
          />
        ))}
      </center>
    </>
  );
}

export default LGEnglish;
